import { createSlice } from '@reduxjs/toolkit';
import { asyncIsFulfilled, asyncIsPending, asyncIsRejected } from '../asyncConfig';
import { endRideById, getAllRides, getRideDetailsById, getRideFulfilled, getRideHistoryById, getUserHistory } from './ride_thunk'

const initialState = {
  rides: [],
  user: {},
  status: '',
  message: ''
}

export const rideSlice = createSlice({
  name: 'rides',
  initialState,
  extraReducers: {
    [endRideById.pending]: asyncIsPending,
    [endRideById.rejected]: asyncIsRejected,
    [endRideById.fulfilled]: asyncIsFulfilled,
    [getAllRides.pending]: asyncIsPending,
    [getAllRides.rejected]: asyncIsRejected,
    [getAllRides.fulfilled]: getRideFulfilled,
    [getRideDetailsById.pending]: asyncIsPending,
    [getRideDetailsById.rejected]: asyncIsRejected,
    [getRideDetailsById.fulfilled]: getRideFulfilled,
    [getRideHistoryById.pending]: asyncIsPending,
    [getRideHistoryById.rejected]: asyncIsRejected,
    [getRideHistoryById.fulfilled]: getUserHistory
  }
});

export default rideSlice.reducer;